import React from 'react';

const Footer = () => {
    return (<footer className="Footer">
        <div className='Custom-Grid'>
            Custom Footer
        </div>
    </footer>)
}

export default React.memo(Footer);
